type Region = 'americas' | 'europe'
type Locale = 'fr_FR' | 'en_EN' | 'es_ES'

const REGION_COOKIE = 'region_pref'
const LOCALE_COOKIE = 'locale_pref'
const DISMISS_COOKIE = 'region_modal_dismissed'

const DAY = 60 * 60 * 24
const PREF_TTL = 7 * DAY
const DISMISS_TTL = 12 * 60 * 60

const readCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : null
}

const writeCookie = (name: string, value: string, maxAge: number) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`
}

const redirectPopin = () => {
    return {
        show: false,
        region: 'europe' as Region,
        locale: 'en_EN' as Locale,
        localeUrls: {} as Record<Locale, string>,

        onDismiss() {
            writeCookie(DISMISS_COOKIE, '1', DISMISS_TTL)
            this.show = false
        },

        onConfirm() {
            writeCookie(REGION_COOKIE, this.region, PREF_TTL)
            writeCookie(LOCALE_COOKIE, this.locale, PREF_TTL)
            const target = this.localeUrls[this.locale]
            if (target) {
                window.location.href = target
            } else {
                window.location.reload()
            }
        },

        init() {
            const el = (this as any).$el as HTMLElement
            this.region = (el.dataset.region as Region) || this.region
            this.locale = (el.dataset.locale as Locale) || this.locale
            try {
                this.localeUrls = JSON.parse(el.dataset.localeUrls || '{}')
            } catch {
                this.localeUrls = {} as Record<Locale, string>
            }

            if (readCookie(REGION_COOKIE)) return
            if (readCookie(DISMISS_COOKIE)) return
            this.show = true
        },
    }
}

(window as any).redirectPopin = redirectPopin
